import React from "react";

// style imports
import "./cookiesBanner.scss";

// plugin imports
import { useLocation } from "@reach/router";
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies";
import { Trans, useTranslation } from "@herob191/gatsby-plugin-react-i18next";
import { AnimatePresence, motion } from "motion/react";
import { Link } from "gatsby";

// import IconoCookies from "./iconoCookies.svg";

// component imports
import ClientOnly from "./clientOnly";

import ToggleButton from "./toggleButton";

// function exports for use in other pages
export const addCookies = (date, location) => {
	// console.log("addCookies running");
	const acceptAppendix = "=true;path=/;SameSite=none;Secure";
	// expires=" + date.toGMTString();
	// console.log(acceptAppendix);

	if (typeof document != "undefined") {
		document.cookie = "cookiesStored" + acceptAppendix;
		document.cookie = "cookiesAccepted" + acceptAppendix;
		document.cookie = "gatsby-gdpr-google-analytics" + acceptAppendix;
		document.cookie = "gatsby-gdpr-facebook-pixel" + acceptAppendix;
		document.cookie = "gatsby-gdpr-google-tagmanager" + acceptAppendix;
		document.cookie = "gatsby-gdpr-tiktok-pixel" + acceptAppendix;
		document.cookie = "gatsby-gdpr-hotjar" + acceptAppendix;
		document.cookie = "gatsby-gdpr-linked-in" + acceptAppendix;

		// console.log("Initializing tracking");
		initializeAndTrack(location);
	}
};
export const rejectCookies = (date) => {
	// console.log("rejectCookies running");
	const rejectAppendix =
		"=false;path=/;SameSite=none;Secure;expires=" + date.toGMTString();

	if (typeof document != "undefined") {
		document.cookie = "cookiesStored";

		document.cookie = "cookiesAccepted" + rejectAppendix;
		document.cookie = "gatsby-gdpr-google-analytics" + rejectAppendix;
		document.cookie = "gatsby-gdpr-facebook-pixel" + rejectAppendix;
		document.cookie = "gatsby-gdpr-google-tagmanager" + rejectAppendix;
		document.cookie = "gatsby-gdpr-tiktok-pixel" + rejectAppendix;
		document.cookie = "gatsby-gdpr-hotjar" + rejectAppendix;
		document.cookie = "gatsby-gdpr-linked-in" + rejectAppendix;
	}
};
export const getCookie = (name) => {
	if (typeof document != "undefined") {
		// console.log(document);
		var v = document?.cookie?.match("(^|;) ?" + name + "=([^;]*)(;|$)");
		// console.log(v);
		if (v) {
			if (v[2] === "true") {
				return true;
			} else if (v[2] === "false") {
				return false;
			} else {
				return v[2];
			}
		}
	}
	return null;
};
export const resetCookiesPanel = () => {
	// console.log("rejectCookies running")
	const oneYear = 365 * 24 * 60 * 60 * 1000; //one year in seconds, to set expiry date for the cookie
	const rejectAppendix =
		"=false;path=/;SameSite=none;Secure;Max-Age=" + oneYear;

	if (typeof document != "undefined") {
		document.cookie = "cookiesStored" + rejectAppendix;
	}
};

export default function CookiesBanner() {
	const { t } = useTranslation("cookiesBanner");

	const [customizeCookies, setCustomizeCookies] = React.useState(false);
	const [funcCookies, setFuncCookies] = React.useState(true); // eslint-disable-line
	const [mktCookies, setMktCookies] = React.useState(
		getCookie("cookiesAccepted")
	);
	const [cookiesStored, setCookiesStored] = React.useState(
		getCookie("cookiesStored")
	);

	const location = useLocation();

	React.useEffect(() => {
		// console.log("useEffect running");
		// we have to do this inside the useEffect to prevent Date mismatches from server to client
		const expiry = new Date();
		expiry.setTime(expiry.getTime() + 365 * 24 * 60 * 60 * 1000);

		if (mktCookies && cookiesStored) {
			// if cookies are accepted and have not been previously added, store them
			// console.log("Accepting cookies");
			addCookies(expiry, location);
		}

		if (!mktCookies && cookiesStored) {
			// if cookies are disabled, remove them
			// console.log("Rejecting cookies");s
			rejectCookies(expiry);
		}
	}, [mktCookies, cookiesStored, location]);

	const slideUp = {
		initial: "hidden",
		animate: "animate",
		exit: "hidden",
		variants: {
			hidden: {
				height: 0,
			},
			animate: {
				height: "auto",
			},
		},
		style: { overflow: "hidden" },
	};

	return (
		<ClientOnly className="cookiesContainer padding">
			<AnimatePresence mode="wait">
				{cookiesStored ? (
					<motion.button
						{...slideUp}
						className="cookiesButton padding borderThick blurBg"
						onClick={() => {
							setCookiesStored(false);
						}}
					>
						<p className="h2">Cookies</p>
					</motion.button>
				) : (
					<motion.div {...slideUp} className="cookiesBanner borderThick blurBg">
						<div className="padding">
							<span className="h2">
								<Trans>Cookies</Trans>
							</span>

							<p>
								<Trans>
									Utilizamos cookies propias y de terceros que nos ofrecen datos
									estadísticos y hábitos de navegación de los usuarios; esto nos
									ayuda a mejorar nuestros contenidos y servicios, incluso
									mostrar publicidad relacionada con las preferencias de los
									usuarios. Más información en nuestra{" "}
									<Link to="legal/politica-cookies">Política de Cookies</Link>
								</Trans>
							</p>
							<AnimatePresence>
								{customizeCookies && (
									<motion.div
										className="customCookies overflowPadding"
										{...slideUp}
									>
										<div className="border padding">
											<div>
												<ToggleButton
													label={t("Técnicas")}
													checked={funcCookies}
													disabled
												/>
												<ToggleButton
													label={t("Marketing")}
													checked={mktCookies}
													onClick={() => {
														setMktCookies(!mktCookies);
													}}
												/>
											</div>
											<div className="saveConfig">
												<button
													onClick={() => {
														setCookiesStored(true);
													}}
													className="underlineHover"
													aria-label={t("Guardar configuración")}
												>
													<span className="h3">
														<Trans>Guardar config</Trans>
													</span>
												</button>
											</div>
										</div>
									</motion.div>
								)}
							</AnimatePresence>

							<div className="buttons">
								<button
									className="noCookies underlineHover"
									onClick={() => setCustomizeCookies(!customizeCookies)}
									aria-label={t("Personalizar cookies")}
								>
									<span className="h3">
										<Trans>Personalizar cookies</Trans>
									</span>
								</button>
								<button
									className="noCookies underlineHover"
									onClick={() => {
										setCookiesStored(true);
										setMktCookies(false);
									}}
									aria-label={t("Rechazar cookies")}
								>
									<span className="h3">
										<Trans>Rechazar cookies</Trans>
									</span>
								</button>
								<button
									className="underlineHover"
									onClick={() => {
										setCookiesStored(true);
										setMktCookies(true);
									}}
									aria-label={t("Aceptar cookies")}
								>
									<span className="h2">
										<Trans>Aceptar cookies</Trans>
									</span>
								</button>
							</div>
						</div>
					</motion.div>
				)}
			</AnimatePresence>
		</ClientOnly>
	);
}
